import * as logout from './reducers/logout';
import * as login from './reducers/login';
import * as signup from './reducers/signup';
import * as forgot from './reducers/forgot';
import * as cancelWithdrawal from './reducers/cancel-withdrawal';
import * as changePassword from './reducers/change-password';
import * as changeAddress from './reducers/change-address';
import * as changeEmail from './reducers/change-email';
import * as changeContactNumber from './reducers/change-contact-number';
import * as changeOdds from './reducers/change-odds';
import * as resetPassword from './reducers/reset-password';
import * as getTransactions from './reducers/get-transactions';
import * as universeSwitch from './reducers/universe-switch';

// eslint-disable-next-line import/no-default-export
export default {
    USER_LOGIN_REQUEST: login.request,
    USER_LOGOUT_REQUEST: logout.request,
    USER_SIGNUP_REQUEST: signup.request,
    USER_FORGOT_REQUEST: forgot.request,
    USER_CANCEL_WITHDRAWAL_REQUEST: cancelWithdrawal.request,
    USER_CHANGE_PASSWORD_REQUEST: changePassword.request,
    USER_CHANGE_EMAIL_REQUEST: changeEmail.request,
    USER_CHANGE_CONTACT_NUMBER_REQUEST: changeContactNumber.request,
    USER_CHANGE_ADDRESS_REQUEST: changeAddress.request,
    USER_CHANGE_ODDS_REQUEST: changeOdds.request,
    USER_RESET_PASSWORD_REQUEST: resetPassword.request,
    USER_GET_TRANSACTIONS_REQUEST: getTransactions.request,
    UNIVERSE_SWITCH_REQUEST: universeSwitch.request,
};
